import en from "./locales/en";
import sv from "./locales/sv";

export default {
  sv,
  en
};
